/** Roles asignables en el espacio de trabajo (Configuración → Usuarios). */
export const WORKSPACE_ASSIGNABLE_ROLES = ["admin", "user", "consulta", "revendedor"];

export const WORKSPACE_ROLE_LABELS = {
  admin: "Administrador de equipo",
  user: "Auxiliar contable",
  consulta: "Consulta (solo lectura)",
  revendedor: "Revendedor",
  platform_designer: "Diseñador plataforma BNT",
  buyer_admin: "Administrador comprador",
};

export const WORKSPACE_ROLE_BADGE_CLASS = {
  admin: "bg-emerald-100 text-emerald-800",
  user: "bg-slate-100 text-slate-700",
  consulta: "bg-blue-100 text-blue-900",
  revendedor: "bg-violet-100 text-violet-900",
  platform_designer: "bg-amber-100 text-amber-950",
  buyer_admin: "bg-sky-100 text-sky-900",
};

/**
 * Etiqueta legible del rol de un usuario en listados y modales.
 * @param {string} role
 * @param {{ is_admin_owner?: boolean, is_buyer_tenant?: boolean }} [user]
 */
export function getWorkspaceRoleLabel(role, user = {}) {
  if (user?.is_admin_owner && role === "platform_designer") {
    return WORKSPACE_ROLE_LABELS.platform_designer;
  }
  if (user?.is_admin_owner && role === "admin") {
    return "Propietario / Administrador";
  }
  if (role === "buyer_admin" || (user?.is_buyer_tenant && role === "buyer_admin")) {
    return WORKSPACE_ROLE_LABELS.buyer_admin;
  }
  return WORKSPACE_ROLE_LABELS[role] || role || "—";
}

export function getWorkspaceRoleBadgeClass(role, user = {}) {
  if (user?.is_admin_owner && (role === "platform_designer" || role === "admin")) {
    return WORKSPACE_ROLE_BADGE_CLASS.platform_designer;
  }
  return WORKSPACE_ROLE_BADGE_CLASS[role] || WORKSPACE_ROLE_BADGE_CLASS.user;
}

/** Roles que no deben cambiarse desde Configuración → Usuarios. */
export function isWorkspaceRoleLocked(target) {
  if (!target) return true;
  if (target.is_admin_owner) return true;
  if (target.is_buyer_tenant) return true;
  if (target.role === "platform_designer") return true;
  if (target.role === "buyer_admin") return true;
  return false;
}

/**
 * Opciones del selector según contexto.
 * @param {{ showReseller?: boolean, includeConsulta?: boolean, targetRole?: string }} opts
 */
export function getAssignableWorkspaceRoleOptions({
  showReseller = false,
  includeConsulta = true,
  targetRole = "",
} = {}) {
  const opts = [
    { value: "admin", label: WORKSPACE_ROLE_LABELS.admin },
    { value: "user", label: WORKSPACE_ROLE_LABELS.user },
  ];
  if (includeConsulta) {
    opts.push({ value: "consulta", label: WORKSPACE_ROLE_LABELS.consulta });
  }
  if (showReseller || targetRole === "revendedor") {
    opts.push({ value: "revendedor", label: WORKSPACE_ROLE_LABELS.revendedor });
  }
  return opts;
}

/** Valor seguro para Radix Select (debe existir en las opciones o caer a user). */
export function normalizeEditableRole(role, options) {
  const values = new Set(options.map((o) => o.value));
  if (values.has(role)) return role;
  if (role === "platform_designer" || role === "buyer_admin") return role;
  return "user";
}
